/* Product page hero test (added 3 Nov 2026). The version is picked in snippets/pdp-hero-test.liquid,
   which sets window.DongarPdpTest on the four test pages (PRO+, Classic+, Classic, PRO).

   Loaded site-wide (layout/theme.liquid). Does nothing visible. Four jobs:

   1. On a test page, log the visit to Supabase (pdp-events → public.pdp_test_events) with whether it
      counts: Fit Finder hand-offs (their clicks belong to the finder test), reloads and back/forward
      visits are logged but marked eligible = false. Also logs when the buy box comes into view, a page
      that scrolled itself before the shopper touched it, add to cart and "Buy on Amazon" clicks.
   2. "Buy on Amazon" (US links only) is sent with the version's Amazon Attribution tag instead of
      website_product, swapped at click time. Finder hand-offs keep their finder tag
      (dongar-arm-handoff.js). Any other link is left exactly as it is.
   3. On any page, an add to cart by a visitor who has had a counted test visit stamps the cart with a
      hidden attribute (_pdp_variant: hero / nohero), so Shopify orders show which version they saw.
   4. QA visits (?pdp_test=...) are logged with mode 'qa', stamped qa_hero / qa_nohero, never counted.

   Nothing here may break the page: every step is wrapped, clicks are never blocked or delayed. */
(function () {
  'use strict';
  if (window.__dgrPdpTest) return;
  window.__dgrPdpTest = true;

  var SEEN_KEY = 'dongar_pdp_seen';
  var SEEN_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var ENDPOINT = 'https://vdfgvxqwcjdupvtjhnmy.supabase.co/functions/v1/pdp-events';

  /* US website_product ad group → each version's ad group (Finder Outclicks campaign). */
  var WEBSITE_PRODUCT_TAG = 'F6A08B15BF236D52F66AE98D60A53ABB';
  var VARIANT_TAG = {
    hero:   'B1D12DDC9E5CDF644FD45314E79DC302', // pdp_test_hero
    nohero: '5C8C181A229BD79CBB0CB356BCB81358'  // pdp_test_nohero
  };

  /* Same marker dongar-arm-handoff.js leaves when a Fit Finder test page sends a shopper here. */
  var FF_MARK_KEY = 'dongar_ff_handoff';
  var FF_TTL_MS = 2 * 60 * 60 * 1000;
  var FF_ARMS = ['v2_challenger', 'v3_cta', 'c_assistant'];

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  function productPath(href) {
    try {
      var m = /\/products\/([^\/?#]+)/.exec(new URL(href, location.href).pathname);
      return m ? '/products/' + m[1].toLowerCase() : null;
    } catch (e) { return null; }
  }

  function finderHandoff() {
    try {
      var m = JSON.parse(lsGet(FF_MARK_KEY) || 'null');
      return !!(m && FF_ARMS.indexOf(m.arm) >= 0 && m.ts && Date.now() - m.ts <= FF_TTL_MS &&
        m.path === productPath(location.href));
    } catch (e) { return false; }
  }

  function send(payload) {
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }

  /* ── 3/4. Add to cart anywhere: stamp the cart with the version ── */
  var cartTagged = false;
  function stampCart() {
    try {
      if (cartTagged) return;
      var seen = JSON.parse(lsGet(SEEN_KEY) || 'null');
      if (!seen || !VARIANT_TAG[seen.v] || !seen.t || Date.now() - seen.t > SEEN_TTL_MS) return;
      cartTagged = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _pdp_variant: (seen.mode === 'qa' ? 'qa_' : '') + seen.v } })
      }).catch(function () { cartTagged = false; });
    } catch (e) {}
  }

  var T = window.DongarPdpTest;
  var onTestPage = !!(T && VARIANT_TAG[T.variant]);
  var base = null;
  var atcLogged = false;

  function onCartAdd() {
    stampCart();
    if (onTestPage && base && !atcLogged) {
      atcLogged = true;
      send(Object.assign({}, base, { event: 'add_to_cart' }));
    }
  }
  /* Watches network requests without touching them: any request to /cart/add (theme forms, quick
     buys, the finder's own buttons) shows up here once it has been sent. */
  try {
    if ('PerformanceObserver' in window) {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (/\/cart\/add(\.js)?(\?|$)/.test(en.name)) onCartAdd();
        });
      }).observe({ type: 'resource', buffered: false });
    }
  } catch (e) {}

  if (!onTestPage) return;

  /* ── 1. The visit ── */
  try {
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var navType = nav.type || 'navigate';
    var handoff = finderHandoff();
    var reason = handoff ? 'finder_handoff'
      : navType === 'reload' ? 'reload'
      : navType === 'back_forward' ? 'back_forward' : null;
    var A = window.DongarAttribution;
    var path = productPath(location.href);
    base = {
      visitor_id: T.visitorId,
      view_id: T.visitorId + '-' + Date.now().toString(36),
      variant: T.variant,
      mode: T.mode,
      product: path ? path.replace('/products/', '') : null,
      device: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
    };
    send(Object.assign({}, base, {
      event: 'view',
      nav_type: navType,
      eligible: !reason,
      exclude_reason: reason,
      arrival_hash: T.droppedHash || null,
      source: A && typeof A.source === 'function' ? (A.source() || null) : null,
      bucket: A && typeof A.bucket === 'function' ? (A.bucket() || null) : null
    }));
    if (!reason) lsSet(SEEN_KEY, JSON.stringify({ v: T.variant, mode: T.mode, t: Date.now() }));

    /* A page that scrolled itself before any input skipped the top: flag it so it can be left out. */
    setTimeout(function () {
      try {
        if (!T.touched() && window.scrollY > 200) send(Object.assign({}, base, { event: 'auto_scrolled', value: Math.round(window.scrollY) }));
      } catch (e) {}
    }, 2000);

    /* Buy box in view (once per visit). */
    var box = document.querySelector('.pdpc-buybar-wrap, [id$="__main"] .product-form__buttons, [id$="__main"] form[action*="/cart/add"]');
    if (box && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          io.disconnect();
          send(Object.assign({}, base, { event: 'buybox_seen', value: Math.round(window.scrollY) }));
        }
      }, { threshold: 0.5 });
      io.observe(box);
    }
  } catch (e) {}

  /* ── 2. "Buy on Amazon" ── */
  var amzLogged = false;
  function onAmazon(e) {
    try {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a || !base) return;
      var host = new URL(a.href).hostname.toLowerCase();
      var mkt = /(^|\.)amazon\.com$/.test(host) ? 'US' : /(^|\.)amazon\.ca$/.test(host) ? 'CA'
        : /(^|\.)amazon\.co\.uk$/.test(host) ? 'GB' : /(^|\.)amazon\./.test(host) ? 'XX' : null;
      if (!mkt) return;
      if (mkt === 'US' && !finderHandoff() && a.href.indexOf('maas_adg_' + WEBSITE_PRODUCT_TAG) >= 0) {
        a.href = a.href.replace('maas_adg_' + WEBSITE_PRODUCT_TAG, 'maas_adg_' + VARIANT_TAG[T.variant]);
      }
      if (!amzLogged) {
        amzLogged = true;
        send(Object.assign({}, base, { event: 'amazon_click', marketplace: mkt, sku: a.getAttribute('data-sku') || null }));
      }
    } catch (err) {}
  }
  document.addEventListener('click', onAmazon, true);
  document.addEventListener('auxclick', onAmazon, true);
})();
